// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1680":"9cb710f045ca9994","4213":"7e6df38499609c66","6991":"2c132a4509698d7a"}[chunkId] + ".css";
};